// Import necessary components and hooks
import React from "react";
import { GalleryItem } from "./GalleryItem";
import { Button } from "@/shared/ui/button";
import { Plus } from "lucide-react";

interface PresetGalleryProps {
  galleryItems: { id: string; before: string | null; after: string | null }[];
  addGalleryItem: () => void;
  removeGalleryItem: (id: string) => void;
  handleGalleryPhotoChange: (
    itemId: string,
    type: "before" | "after",
    e: React.ChangeEvent<HTMLInputElement>
  ) => void;
  isLoading?: boolean;
  hasPermissionError?: boolean;
  hasError?: boolean;
  onDeleteGalleryItem?: (id: string) => void;
}

export const PresetGallery: React.FC<PresetGalleryProps> = ({
  galleryItems,
  addGalleryItem,
  removeGalleryItem,
  handleGalleryPhotoChange,
  isLoading = false,
  hasPermissionError = false,
  hasError = false,
  onDeleteGalleryItem,
}) => {
  return (
    <div
      className={`space-y-4 ${hasError ? "border border-red-500 p-4 rounded-md" : ""
        }`}
    >
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-bold text-white">Galeria</h2>
        <Button
          type="button"
          onClick={addGalleryItem}
          className="bg-white/10 hover:bg-white/20 text-white"
        >
          <Plus className="h-4 w-4 mr-2" />
          Adicionar Foto
        </Button>
      </div>

      {/* Display error message if needed */}
      {hasError && (
        <div className="text-red-500 text-sm mt-1">
          Adicione pelo menos uma foto completa (antes e depois) na galeria
        </div>
      )}

      <div className="flex flex-wrap gap-4">
        {galleryItems.map((item) => (
          <div key={item.id} className="relative">
            <GalleryItem
              id={item.id}
              before={item.before}
              after={item.after}
              onChange={(type, e) => handleGalleryPhotoChange(item.id, type, e)}
              onRemove={() => removeGalleryItem(item.id)}
              isLoading={isLoading}
              hasPermissionError={hasPermissionError}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
